module.exports = __webpack_public_path__ + "img/top.81a482b9.jpg";